import React from 'react'

function ApiContent() {
  return (
    <div className="container">
      <h1>This is the Api Call page.</h1>
      <p>Content coming soon.</p>
    </div>
  )
}

export default ApiContent